"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserStsuiClaimedAirdrop = exports.getUserStsuiAirdrop = exports.getAlphaUnlockedTillNow = exports.getTotalAlphaToBeRelocked = exports.getWhenUserIsEligibleForAirdrop = exports.getAlphaLockedPercentage = exports.getLostAmountOnWithdraw = exports.getTotalAirdropForUser = exports.getAirdropData = exports.getLockedTableFromDyanmicField = exports.fetchUserLockedBalances = void 0;
exports.getAirdropRelockAmount = getAirdropRelockAmount;
exports.getClaimedAirdrop = getClaimedAirdrop;
exports.getLastClaimedAirdropTimestamp = getLastClaimedAirdropTimestamp;
exports.getAirdropEvent = getAirdropEvent;
const tslib_1 = require("tslib");
const decimal_js_1 = require("decimal.js");
const index_js_1 = require("./protocol/index.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const simpleCache_js_1 = require("./protocol/simpleCache.js");
const fetchUserLockedBalances = async (options, ignoreCache) => {
    const poolName = "ALPHA";
    const receipts = await (0, alphafi_sdk_1.getReceipts)(poolName, options.address, ignoreCache);
    if (receipts.length <= 0) {
        return []; // if pool has 0 Alpha receipts
    }
    const lockedTableID = receipts[0].content.fields.locked_balance?.fields.id.id;
    const exchangeRate = await (0, index_js_1.getPoolExchangeRate)(poolName, ignoreCache);
    if (exchangeRate && lockedTableID) {
        const lockedAlphaDetailsArray = await (0, exports.getLockedTableFromDyanmicField)(lockedTableID, exchangeRate, ignoreCache);
        return lockedAlphaDetailsArray;
    }
    return [];
};
exports.fetchUserLockedBalances = fetchUserLockedBalances;
const lockedTableCache = new simpleCache_js_1.SimpleCache();
const lockedTablePromiseCache = new simpleCache_js_1.SimpleCache();
const getLockedTableFromDyanmicField = async (lockedTableID, exchangeRate, ignoreCache) => {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const lockedTableCacheKey = `getLockedTable-${lockedTableID}`;
    if (ignoreCache) {
        lockedTableCache.delete(lockedTableCacheKey);
        lockedTablePromiseCache.delete(lockedTableCacheKey);
    }
    const cachedResponse = lockedTableCache.get(lockedTableCacheKey);
    if (cachedResponse) {
        return cachedResponse;
    }
    let cachedPromise = lockedTablePromiseCache.get(lockedTableCacheKey);
    if (!cachedPromise) {
        cachedPromise = (async () => {
            let lockedAlphaDetailsArray = [];
            let locked_alpha_pos_arr = [];
            let currentCursor = null;
            do {
                const response = await suiClient.getDynamicFields({
                    parentId: lockedTableID,
                    cursor: currentCursor,
                });
                locked_alpha_pos_arr = locked_alpha_pos_arr.concat(response.data);
                if (response.hasNextPage && response.nextCursor) {
                    currentCursor = response.nextCursor;
                }
                else {
                    break;
                }
            } while (true);
            if (locked_alpha_pos_arr.length > 0) {
                const promises = locked_alpha_pos_arr.map(async (locked_obj) => {
                    const locked_item1 = await suiClient.getDynamicFieldObject({
                        parentId: lockedTableID,
                        name: locked_obj.name,
                    });
                    if (locked_item1 && locked_item1.data) {
                        const locked_item_object = locked_item1.data;
                        return {
                            value: new decimal_js_1.Decimal(locked_item_object.content.fields.value.fields.value)
                                .mul(exchangeRate)
                                .div(1e9)
                                .toString(),
                            xTokenBalance: locked_item_object.content.fields.value.fields.value,
                            timestamp: locked_item_object.content.fields.name,
                        };
                    }
                    return {
                        value: "0",
                        xTokenBalance: "0",
                        timestamp: "0",
                    };
                });
                const results = await Promise.all(promises);
                lockedAlphaDetailsArray = results.filter((result) => {
                    return result != undefined;
                });
                lockedAlphaDetailsArray.sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
            }
            lockedTableCache.set(lockedTableCacheKey, lockedAlphaDetailsArray);
            lockedTablePromiseCache.delete(lockedTableCacheKey);
            return lockedAlphaDetailsArray;
        })().catch((error) => {
            lockedTablePromiseCache.delete(lockedTableCacheKey);
            throw error;
        });
        lockedTablePromiseCache.set(lockedTableCacheKey, cachedPromise);
    }
    return cachedPromise;
};
exports.getLockedTableFromDyanmicField = getLockedTableFromDyanmicField;
function convertAsciiArrayToString(asciiArray) {
    return asciiArray.map((code) => String.fromCharCode(code)).join("");
}
const airdropDataCache = new simpleCache_js_1.SimpleCache();
const airdropDataPromiseCache = new simpleCache_js_1.SimpleCache();
const getAirdropData = async (ignoreCache) => {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const airdropDataCacheKey = `getAirdropData`;
    if (ignoreCache) {
        airdropDataCache.delete(airdropDataCacheKey);
        airdropDataPromiseCache.delete(airdropDataCacheKey);
    }
    const cachedResponse = airdropDataCache.get(airdropDataCacheKey);
    if (cachedResponse) {
        return cachedResponse;
    }
    let cachedPromise = airdropDataPromiseCache.get(airdropDataCacheKey);
    if (!cachedPromise) {
        cachedPromise = (async () => {
            let airdrop_rate_name = undefined;
            let airdrop_cycle_start_timestamp_name = undefined;
            let currentCursor = null;
            do {
                const response = await suiClient.getDynamicFields({
                    parentId: (0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR,
                    cursor: currentCursor,
                });
                const arr = response.data;
                arr.forEach((data) => {
                    const name = convertAsciiArrayToString(data.name.value);
                    if (name === "airdrop_rate") {
                        airdrop_rate_name = data.name;
                    }
                    else if (name === "airdrop_cycle_start_timestamp") {
                        airdrop_cycle_start_timestamp_name = data.name;
                    }
                });
                if (response.hasNextPage &&
                    response.nextCursor &&
                    !airdrop_rate_name &&
                    !airdrop_cycle_start_timestamp_name) {
                    currentCursor = response.nextCursor;
                }
                else {
                    break;
                }
                console.log("repeat data");
            } while (true);
            let airdrop_rate;
            let airdrop_cycle_start_timestamp;
            if (airdrop_rate_name !== undefined) {
                const res = await suiClient.getDynamicFieldObject({
                    parentId: (0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR,
                    name: airdrop_rate_name,
                });
                airdrop_rate = res.data;
            }
            else {
                console.error("airdrop_rate is yet to be added in distributor dynamic fields");
            }
            if (airdrop_cycle_start_timestamp_name !== undefined) {
                const res = await suiClient.getDynamicFieldObject({
                    parentId: (0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR,
                    name: airdrop_cycle_start_timestamp_name,
                });
                airdrop_cycle_start_timestamp = res.data;
            }
            else {
                console.error("airdrop_cycle_start_timestamp is yet to be added in distributor dynamic fields");
            }
            airdropDataCache.set(airdropDataCacheKey, [
                Number(airdrop_rate?.content.fields.value),
                Number(airdrop_cycle_start_timestamp?.content.fields.value),
            ]);
            airdropDataPromiseCache.delete(airdropDataCacheKey);
            return [
                Number(airdrop_rate?.content.fields.value),
                Number(airdrop_cycle_start_timestamp?.content.fields.value),
            ];
        })().catch((error) => {
            airdropDataPromiseCache.delete(airdropDataCacheKey);
            throw error;
        });
        airdropDataPromiseCache.set(airdropDataCacheKey, cachedPromise);
    }
    return cachedPromise;
};
exports.getAirdropData = getAirdropData;
const getTotalAirdropForUser = async (options, ignoreCache) => {
    const [airdrop_rate, airdrop_cycle_start_timestamp] = await (0, exports.getAirdropData)(ignoreCache);
    const lockedBalances = await (0, exports.fetchUserLockedBalances)(options, ignoreCache);
    const airdrop_cycle_last_timestamp = airdrop_cycle_start_timestamp + 98 * 86400000;
    let totalXTokens = 0;
    lockedBalances.forEach((singleLock) => {
        if (singleLock.timestamp >= airdrop_cycle_start_timestamp &&
            singleLock.timestamp < airdrop_cycle_last_timestamp) {
            totalXTokens += Number(singleLock.xTokenBalance);
        }
    });
    const totalAirdrop = totalXTokens * airdrop_rate;
    return totalAirdrop / 1e18;
};
exports.getTotalAirdropForUser = getTotalAirdropForUser;
const getLostAmountOnWithdraw = async (options, ignoreCache) => {
    const currentTimestamp = Date.now();
    const [airdrop_rate, airdrop_cycle_start_timestamp] = await (0, exports.getAirdropData)(ignoreCache);
    const lockedBalances = await (0, exports.fetchUserLockedBalances)(options, ignoreCache);
    const airdrop_cycle_last_timestamp = airdrop_cycle_start_timestamp + 98 * 86400000;
    let xTokensTillNow = 0;
    let flag = true;
    lockedBalances.forEach((singleLock) => {
        if (singleLock.timestamp >= airdrop_cycle_start_timestamp &&
            singleLock.timestamp < airdrop_cycle_last_timestamp) {
            if (currentTimestamp < singleLock.timestamp && flag)
                return 0;
            else
                flag = false;
            if (currentTimestamp >= singleLock.timestamp)
                xTokensTillNow += Number(singleLock.xTokenBalance);
        }
    });
    const airdropTillNow = xTokensTillNow * airdrop_rate;
    return airdropTillNow / 1e18;
};
exports.getLostAmountOnWithdraw = getLostAmountOnWithdraw;
//(alpha + alpha-sui + alpha-wusdc) / circulation_supply
const getAlphaLockedPercentage = async (ignoreCache) => {
    const genesis_epoch = 1719519457000;
    let durationInDays = (Date.now() - genesis_epoch) / (1000 * 60 * 60 * 24);
    let initialRate = 42500;
    let circulation_supply = 1500000;
    while (durationInDays > 0) {
        circulation_supply +=
            durationInDays > 100 ? 100 * initialRate : durationInDays * initialRate;
        durationInDays = durationInDays - 100;
        initialRate = initialRate / 2;
    }
    const alphaPool = await (0, alphafi_sdk_1.getPool)("ALPHA", ignoreCache);
    const alphaInAlphaSui = await getAlphaAmountInPool("ALPHA-SUI", ignoreCache);
    const alphaInAlphaWusdc = await getAlphaAmountInPool("ALPHA-WUSDC", ignoreCache);
    let numerator = new decimal_js_1.Decimal(0);
    if (alphaPool && alphaInAlphaSui && alphaInAlphaWusdc) {
        const alpha = new decimal_js_1.Decimal(alphaPool.content.fields.tokensInvested);
        const alphaInAlphaSuiInUSD = alphaInAlphaSui.div(1e9);
        const alphaInAlphaWusdcInUSD = alphaInAlphaWusdc.div(1e9);
        const alphaTVLDecimal = alpha.div(1e9);
        numerator = alphaTVLDecimal
            .add(alphaInAlphaSuiInUSD)
            .add(alphaInAlphaWusdcInUSD);
    }
    const denominator = new decimal_js_1.Decimal(circulation_supply);
    return numerator.div(denominator).mul(100).toString();
};
exports.getAlphaLockedPercentage = getAlphaLockedPercentage;
const getAlphaAmountInPool = async (poolName, ignoreCache) => {
    const pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
    const liquidity = pool?.content.fields.xTokenSupply;
    const cetus_pool = await (0, alphafi_sdk_1.getCetusPool)(poolName, ignoreCache);
    const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
    if (liquidity && cetus_pool) {
        const current_sqrt_price = new bn_js_1.default(cetus_pool.content.fields.current_sqrt_price);
        let upper_tick = parseInt(investor.content.fields.upper_tick);
        let lower_tick = parseInt(investor.content.fields.lower_tick);
        if (Math.abs(lower_tick - Math.pow(2, 32)) < lower_tick) {
            lower_tick = lower_tick - Math.pow(2, 32);
        }
        if (Math.abs(upper_tick - Math.pow(2, 32)) < upper_tick) {
            upper_tick = upper_tick - Math.pow(2, 32);
        }
        const upper_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(upper_tick);
        const lower_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(lower_tick);
        const { coinA } = cetus_sui_clmm_sdk_1.ClmmPoolUtil.getCoinAmountFromLiquidity(new bn_js_1.default(liquidity), current_sqrt_price, lower_sqrt_price, upper_sqrt_price, false);
        const amount0 = new decimal_js_1.Decimal(coinA.toString());
        return amount0;
    }
};
const getWhenUserIsEligibleForAirdrop = async (options, ignoreCache) => {
    const [, airdrop_cycle_start_timestamp] = await (0, exports.getAirdropData)(ignoreCache);
    const lockedBalances = await (0, exports.fetchUserLockedBalances)(options, ignoreCache);
    const airdrop_cycle_last_timestamp = airdrop_cycle_start_timestamp + 98 * 86400000;
    let res;
    for (const singleLock of lockedBalances) {
        if (Number(singleLock.timestamp) >= airdrop_cycle_start_timestamp &&
            Number(singleLock.timestamp) <= airdrop_cycle_last_timestamp) {
            res = singleLock.timestamp;
            break;
        }
    }
    return res;
};
exports.getWhenUserIsEligibleForAirdrop = getWhenUserIsEligibleForAirdrop;
const getTotalAlphaToBeRelocked = async (options, ignoreCache) => {
    const airdrop = await (0, exports.getTotalAirdropForUser)(options, ignoreCache);
    const [, airdrop_cycle_start_timestamp] = await (0, exports.getAirdropData)(ignoreCache);
    const lockedBalances = await (0, exports.fetchUserLockedBalances)(options, ignoreCache);
    const airdrop_cycle_last_timestamp = airdrop_cycle_start_timestamp + 98 * 86400000;
    let alphaLocked = 0;
    for (const singleLock of lockedBalances) {
        if (Number(singleLock.timestamp) >= airdrop_cycle_start_timestamp &&
            Number(singleLock.timestamp) < airdrop_cycle_last_timestamp) {
            alphaLocked += Number(singleLock.value);
        }
    }
    return alphaLocked + airdrop;
};
exports.getTotalAlphaToBeRelocked = getTotalAlphaToBeRelocked;
const getAlphaUnlockedTillNow = async (options, ignoreCache) => {
    const [, airdrop_cycle_start_timestamp] = await (0, exports.getAirdropData)(ignoreCache);
    const current_timestamp = Date.now();
    const lockedBalances = await (0, exports.fetchUserLockedBalances)(options, ignoreCache);
    let alphaUnlocked = 0;
    for (const singleLock of lockedBalances) {
        if (Number(singleLock.timestamp) >= airdrop_cycle_start_timestamp &&
            Number(singleLock.timestamp) < current_timestamp) {
            alphaUnlocked += Number(singleLock.value);
        }
    }
    return alphaUnlocked;
};
exports.getAlphaUnlockedTillNow = getAlphaUnlockedTillNow;
const getUserStsuiAirdrop = async (options, ignoreCache) => {
    const [, airdrop_cycle_start_timestamp] = await (0, exports.getAirdropData)(ignoreCache);
    const lockedBalances = await (0, exports.fetchUserLockedBalances)(options, ignoreCache);
    const airdrop_cycle_last_timestamp = airdrop_cycle_start_timestamp + 98 * 86400000;
    let totalXTokens = 0;
    lockedBalances.forEach((singleLock) => {
        if (singleLock.timestamp >= airdrop_cycle_start_timestamp &&
            singleLock.timestamp < airdrop_cycle_last_timestamp) {
            totalXTokens += Number(singleLock.xTokenBalance);
        }
    });
    const stsuiXTokenRate = 8417000000000 / 1234298167428410; //0.006819259901792077 / 2.0274839354428440636840700563 = 0.003363410078 --> Stsui-Alpha Rate
    const totalAirdrop = totalXTokens * stsuiXTokenRate;
    return totalAirdrop / 1e9;
};
exports.getUserStsuiAirdrop = getUserStsuiAirdrop;
const getUserStsuiClaimedAirdrop = async (options, ignoreCache) => {
    const totalRelockedTokens = await getAirdropRelockAmount(options, ignoreCache);
    const totalClaimedAirdrop = await getClaimedAirdrop(options, ignoreCache);
    const exchangeRate = await (0, index_js_1.getPoolExchangeRate)("ALPHA", ignoreCache);
    const totalXTokens = new decimal_js_1.Decimal(totalRelockedTokens)
        .minus(new decimal_js_1.Decimal(totalClaimedAirdrop))
        .div(exchangeRate || 0)
        .toNumber();
    const stsuiXTokenRate = 8417000000000 / 1234298167428410; //0.006819259901792077 / 2.0274839354428440636840700563 = 0.003363410078 --> Stsui-Alpha Rate
    const totalAirdrop = totalXTokens * stsuiXTokenRate;
    return totalAirdrop;
};
exports.getUserStsuiClaimedAirdrop = getUserStsuiClaimedAirdrop;
async function getAirdropRelockAmount(options, ignoreCache) {
    const airdropEvent = await getAirdropEvent(options, ignoreCache);
    return ((parseFloat((airdropEvent?.parsedJson).relock_amount) / 1e9).toString() || "0");
}
async function getClaimedAirdrop(options, ignoreCache) {
    const airdropEvent = await getAirdropEvent(options, ignoreCache);
    return ((parseFloat((airdropEvent?.parsedJson).airdrop_amount) / 1e9).toString() || "0");
}
async function getLastClaimedAirdropTimestamp(options, ignoreCache) {
    const airdropEvent = await getAirdropEvent(options, ignoreCache);
    return airdropEvent?.timestampMs || "0";
}
const airdropEventCache = new simpleCache_js_1.SimpleCache();
const airdropEventPromiseCache = new simpleCache_js_1.SimpleCache();
async function getAirdropEvent(options, ignoreCache) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const airdropEventCacheKey = `getAirdropEvent-${options.address}`;
    if (ignoreCache) {
        airdropEventCache.delete(airdropEventCacheKey);
        airdropEventPromiseCache.delete(airdropEventCacheKey);
    }
    const cachedResponse = airdropEventCache.get(airdropEventCacheKey);
    if (cachedResponse) {
        return cachedResponse;
    }
    let cachedPromise = airdropEventPromiseCache.get(airdropEventCacheKey);
    if (!cachedPromise) {
        cachedPromise = (async () => {
            let airdropEvent = undefined;
            if (options.address) {
                let cursor = null;
                let hasNextPage = true;
                const unlockCycleStartTime = (await (0, exports.getAirdropData)(false))[1];
                while (hasNextPage && !airdropEvent) {
                    const result = await suiClient.queryEvents({
                        query: {
                            MoveEventType: "0x904f7b5fc4064adc1a3d49b263abe683660ba766f78abd84a454c37c1f102218::alphapool::AirdropClaimEvent",
                        },
                        cursor: cursor,
                        order: "descending",
                    });
                    let breakFlag = false;
                    result.data.map((event) => {
                        if (event.sender === options.address &&
                            Number(event.timestampMs) >= unlockCycleStartTime) {
                            airdropEvent = event;
                        }
                        if (Number(event.timestampMs) < unlockCycleStartTime) {
                            breakFlag = true;
                        }
                    });
                    hasNextPage = result.hasNextPage;
                    cursor = result.nextCursor;
                    if (breakFlag) {
                        break;
                    }
                }
            }
            airdropEventCache.set(airdropEventCacheKey, airdropEvent);
            airdropEventPromiseCache.delete(airdropEventCacheKey);
            return airdropEvent;
        })().catch((err) => {
            airdropEventPromiseCache.delete(airdropEventCacheKey);
            throw err;
        });
        airdropEventPromiseCache.set(airdropEventCacheKey, cachedPromise);
    }
    return cachedPromise;
}
//# sourceMappingURL=locked_balance.js.map